import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { defer, Observable, of } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import packageVersion from '../../../../package.json';

export interface Version {
  version: string;
  name: string;
}

@Injectable({
  providedIn: 'root',
})
export class ApplicationService {
  apiUrl = 'application';
  environment = environment;

  readonly serviceVersion$ = defer(() =>
    this.http.get<Version>(`${this.apiUrl}/info`)
  ).pipe(shareReplay({ bufferSize: 1, refCount: false }));

  constructor(private readonly http: HttpClient) {}

  getStaticVersion(): Version {
    return {
      version: packageVersion.version,
      name: packageVersion.name,
    };
  }

  getServiceVersion(): Observable<Version> {
    return this.serviceVersion$;
  }

  encryptInfo(content: string): Observable<string> {
    if (content) {
      const url = `${this.apiUrl}/encrypt-info`;
      return this.http.post<string>(url, { content });
    }
    return of('');
  }

  verifyCaptChaSolution(response: string): Observable<boolean> {
    const url = `${this.apiUrl}/verify-solution`;

    return this.http.post<boolean>(url, { response });
  }
}
